import type { BlogPostSummaryRequest, BlogPostSummaryResponse } from './utils/types';
import { client } from '../common/client';

/**
 * API client for blog-related operations
 */
class BlogAPIClient {
  /**
   * Fetch a summary of recent blog posts
   * @param limit - Maximum number of posts to return
   * @returns Promise with blog post summary data
   */
  public async getBlogPostsSummary({ limit = 6 }: BlogPostSummaryRequest = {}): Promise<BlogPostSummaryResponse> {
    return await client.get(`/blog/posts/summary?limit=${limit}`).then((res) => res.data);
  }
}

export const blogAPIClient = new BlogAPIClient();
